module.exports = __webpack_public_path__ + "img/volume_down.475df2d5.svg";